const $ = window.$ = window.jQuery = window.jQuery = require('jquery')
const SimpleLightBox = window.SimpleLightBox = require('simpleLightbox')
require('./bootstrap');

const toBase64 = window.toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});


document.querySelectorAll('.cke-content-container img').forEach(element => {
    element.style.height = 'auto'
    element.style.width = '100%'
    element.style.cursor = 'pointer'
    element.addEventListener('click', img => {
        const src = img.target.src
        document.querySelector('.image-modal-wrapper img').src = src
        const modal = document.getElementById('imageModal')
        modal.classList.add('show')
        modal.classList.add('fade')
        modal.style.display = 'block'
    })
})

document.querySelector('#imageModal .modal-content button')?.addEventListener('click', () => {
    const modal = document.getElementById('imageModal')
    modal.classList.remove('show')
    modal.classList.remove('fade')
    modal.style.display = 'none'
})